import { User } from "oidc-client-ts";
import { getConfig } from "../../services/configService";
import { getValidAccessToken } from "../../auth/userManager";

export async function doPut<T>(
  path: string,
  user: User,
  body: unknown = undefined,
  params?: Record<string, string | number | boolean>,
): Promise<T> {
  return await doRequest("PUT", path, body, user, params);
}

export async function doPost<T>(
  path: string,
  user: User,
  body: unknown = undefined,
  params?: Record<string, string | number | boolean>,
): Promise<T> {
  return await doRequest("POST", path, body, user, params);
}

export async function doGet<T>(
  path: string,
  user?: User | null,
  params?: Record<string, string | number | boolean>,
  body?: unknown,
): Promise<T> {
  return await doRequest("GET", path, body, user, params);
}

export async function doDelete<T>(
  path: string,
  user: User,
  body: unknown = undefined,
  params?: Record<string, string | number | boolean>,
): Promise<T> {
  return await doRequest("DELETE", path, body, user, params);
}

async function doRequest<T>(
  method: string,
  path: string,
  body: unknown,
  _user?: User | null,
  params?: Record<string, string | number | boolean>,
): Promise<T> {
  const url = await getUrl(path, params);
  const bodyJson = body ? JSON.stringify(body) : undefined;
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };
  const token = await getValidAccessToken();
  if (token) {
    headers = {
      ...headers,
      Authorization: `Bearer ${token}`,
    };
  }
  const response = await fetch(url.toString(), {
    method: method,
    headers: headers,
    body: bodyJson,
  });

  if (!response.ok) {
    const error = `Error trying to ${method} with path ${path} and body ${bodyJson}. Response: ${response.status}. Headers: ${JSON.stringify(response.headers)}`;
    console.error(error);
    throw { status: response.status, message: error };
  }
  return (await response.json()) as T;
}

async function getUrl(
  path: string,
  params?: Record<string, string | number | boolean>,
) {
  if (!path.startsWith("/")) {
    path = "/" + path;
  }
  const config = await getConfig();
  const url = new URL(`${config.api.baseUrl}${path}`);

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.append(key, String(value));
    });
  }

  return url;
}
